/* Light Visuals: gentle site-wide text reveal.
   Headings, paragraphs, list items, eyebrows and links in the page content fade in and rise a few pixels
   as they scroll into view, siblings slightly staggered. Text is fully visible without JavaScript,
   in the theme editor, and for people who ask for reduced motion. The homepage hero has its own motion.
   Carousels, galleries, popups and folded accordions are left alone so nothing can stay hidden. */
(function () {
  if (window.Shopify && Shopify.designMode) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  var css = '.lv-fade{opacity:0;transform:translateY(12px);transition:opacity 1.1s cubic-bezier(.25,.6,.3,1),transform 1.3s cubic-bezier(.2,.65,.25,1);transition-delay:var(--lv-fade-d,0s)}' +
            '.lv-fade.is-in{opacity:1;transform:none}';
  var st = document.createElement('style');
  st.textContent = css;
  document.head.appendChild(st);

  var main = document.getElementById('MainContent') || document.querySelector('main');
  if (!main) return;
  var SEL = 'h1,h2,h3,h4,p,li,blockquote,figcaption,dt,dd,.lvh-eyebrow,.ol-eyebrow,.lvh-link,.lvh-btn,.ol-link,.lvu__foot,.lvh-tile';
  var SKIP = '.ol-hero,.lvh,.ol-drawer,header,[role="dialog"],form,.product-form,variant-selects,.price,.lv-tp,' +
             'details,.visually-hidden,slider-component,.slider,.product__media-list,.product__media-item,.product-media-modal,' +
             'media-gallery,.thumbnail-list,.lvu__track,modal-dialog,.share-button,.facets,.ol-coll__panel';

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
    });
  }, { rootMargin: '0px 0px -6% 0px', threshold: 0.01 });

  function prepare(scope) {
    var els = scope.querySelectorAll(SEL);
    var counts = new WeakMap();
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.classList.contains('lv-fade')) continue;
      if (el.closest(SKIP)) continue;
      if (el.parentElement && el.parentElement.closest('.lv-fade')) continue; /* parent already fades */
      if (!el.textContent.trim() && !el.querySelector('img')) continue;
      if (el.offsetParent === null && getComputedStyle(el).position !== 'fixed') continue; /* hidden */
      var p = el.parentElement;
      var n = counts.get(p) || 0;
      counts.set(p, n + 1);
      el.style.setProperty('--lv-fade-d', (Math.min(n, 5) * 0.08).toFixed(2) + 's');
      el.classList.add('lv-fade');
      io.observe(el);
    }
  }

  prepare(main);
  /* Safety net: anything still waiting after 6 seconds in the visible area is shown */
  setTimeout(function () {
    document.querySelectorAll('.lv-fade:not(.is-in)').forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.bottom > 0 && r.top < window.innerHeight) el.classList.add('is-in');
    });
  }, 6000);
  /* Content added later (filters, product variant updates) */
  new MutationObserver(function (muts) {
    muts.forEach(function (m) {
      m.addedNodes.forEach(function (n) { if (n.nodeType === 1) prepare(n.parentElement || main); });
    });
  }).observe(main, { childList: true, subtree: true });
})();
